import { graphql } from '@/client/services/api/graphql/gql';

export const createUserContentViewMutation = graphql(`
  mutation CreateUserContentBookmark($userContentBookmark: UserContentBookmarkCreateInput!) {
    createUserContentBookmark(userContentBookmark: $userContentBookmark) {
      id
    }
  }
`);

export const deleteUserContentViewMutation = graphql(`
  mutation DeleteUserContentBookmark($id: String!) {
    deleteUserContentBookmark(id: $id)
  }
`);
